module.exports = __webpack_public_path__ + "static/media/IMG_20180608_155920.c4c78758.jpg";